import React, { ReactElement, useContext } from 'react'
import NavBarButton from './NavBarButton'
import SectionNavBarSettings from './SectionNavBarSettings'
import { useAuth0 } from '@auth0/auth0-react'
import { AppContext } from '../contexts/AppContext'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSignOutAlt, faUserCircle, faUserSlash, faPlaneCircleExclamation } from '@fortawesome/free-solid-svg-icons'
import { authenticationFailed } from '../site/Login'
library.add(faSignOutAlt, faUserCircle, faUserSlash, faPlaneCircleExclamation)

export const UserNavBarToggleButton = (): ReactElement => {
    const { isLoading, isAuthenticated } = useAuth0()
    const { appState } = useContext(AppContext)
    const className = isLoading ? '' : 'disabled'
    return <NavBarButton
        togglesMenu="user-nav-bar"
        className={ className }
        alt={ appState.user?.picture && 'User' }
        src={ appState.user?.picture }
        overlay={ isLoading
            ? 'spinner'
            : authenticationFailed(isLoading, isAuthenticated, appState)
                ? 'user-slash'
                : appState.offlineMode ? 'plane-circle-exclamation' : undefined }
        icon="user-circle" />
}

const UserNavBar = (): ReactElement => {
    const { appDispatch } = useContext(AppContext)
    return <>
        <NavBarButton text="Log out" icon="sign-out-alt" onClick={ () => appDispatch({ type: 'LOG_OUT' }) } className="logout-icon" />
        <SectionNavBarSettings />
    </>
}

export default UserNavBar
